import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const flash = keyframes`
  0% {
    background-color: rgba(0, 0, 0, 1);
  }
  50%,
  100% {
    background-color: rgba(0, 0, 0, 0.3);
  }
`

const Loader = styled.div`
  position: relative;
  margin: ${p => `0 ${p.theme.space[3]}`};

  &,
  &::after,
  &::before {
    border-radius: 50%;
    height: 0.25rem;
    width: 0.25rem;
    background-color: rgba(0, 0, 0, 1);
    animation: ${flash} 1s 0.5s infinite alternate;
  }

  &::after,
  &::before {
    position: absolute;
    top: 0;
    content: '';
  }

  &::after {
    right: -8px;
    animation-delay: 1s;
  }

  &::before {
    left: -8px;
    animation-delay: 0s;
  }
`

export default Loader
